<template>
  <fetch-error
    v-if="error"
    @retry="getAbilities()"
    :error="error"
  ></fetch-error>

  <div v-else class="container">
    <vs-col vs-w="12" class="desc-cont">
      <h3 class="desc">
        لطفا دسترسی های مورد نیاز برای کاربر
        {{ selectedEmployee.phone }} مشخص کنید.
      </h3>
    </vs-col>

    <vs-col vs-w="12">
      <vs-row class="mt-6">
        <vx-card
          v-for="(abilityGroup, index) in abilities"
          :key="index"
    
          class="mb-5 mx-5"
        >
        <div slot="no-body" class="flex flex-col p-0" > 
          <div style="padding: 18px;" class="flex justify-between items-center">
            <h4>{{ abilityGroup.title }}</h4>

            <vs-checkbox
              :value="isAllChecked(abilityGroup)"
              :indeterminate="isIndeterminate(abilityGroup)"
              @input="toggleAll(abilityGroup, $event)"
            >
              انتخاب همه دسترسی‌ها
            </vs-checkbox>
          </div>
          <div>
            <vs-col
              vs-w="6"
              v-for="abilityItem in abilityGroup.data"
              :key="abilityItem.id"
              class="ability-item"
            >
              <div @click="selectAbility(abilityItem.id)">
                <vs-checkbox
                  :value="selectedAbilities.includes(abilityItem.id)"
                >
                  {{ abilityItem.description }}
                </vs-checkbox>
              </div>
            </vs-col>
          </div>
        </div>
        </vx-card>
      </vs-row>
    </vs-col>

    <vs-col class="row justify-start">
      <div class="flex justify-end">
        <vs-button
          @click="save()"
          color="primary"
          class="mt-5"
          block
          icon-pack="feather"
          icon="icon-check"
        >
          ذخیره
        </vs-button>
      </div>

      <div class="flex justify-end ml-5">
        <vs-button
          @click="deleteEmployee()"
          class="mt-5"
          color="danger"
          type="filled"
        >
          حذف کارمند
        </vs-button>
      </div>

    </vs-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FetchError from "../../components/FetchError.vue";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  name: "EmployeeAbilities",
  components: { FetchError },

  props: {
    selectedEmployee: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      abilities: [],
      selectedAbilities: [],
      error: null,
    };
  },

  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },

  mounted() {
    if (this.selectedEmployee) {
      this.getAbilities(this.selectedEmployee.id);
    }
  },

  methods: {
    getAbilities(employeeId) {
      this.$vs.loading();
      this.selectedAbilities = [];
      this.abilities = [];

      providerApiService
        .getEmployeeAbilities(this.currentProvider.id, employeeId)
        .then((result) => {
          this.setGroupByAbilitiesData(result.data);
          this.initialSelectedAbilities(result.data);
        })
        .catch((err) => (this.error = err))
        .finally(() => this.$vs.loading.close());
    },

    selectAbility(abilityId) {
      if (this.selectedAbilities.includes(abilityId)) {
        this.selectedAbilities = this.selectedAbilities.filter(
          (id) => id !== abilityId
        );
      } else {
        this.selectedAbilities.push(abilityId);
      }
    },

    initialSelectedAbilities(abilities) {
      abilities.forEach((item) => {
        if (item.value) {
          this.selectedAbilities.push(item.id);
        }
      });
    },

    getGroupIds(group) {
      return group?.data?.map((item) => item.id) || [];
    },

    isAllChecked(group) {
      const ids = this.getGroupIds(group);
      return ids.length && ids.every((id) => this.selectedAbilities.includes(id));
    },

    isIndeterminate(group) {
      const ids = this.getGroupIds(group);
      const checkedCount = ids.filter((id) =>
        this.selectedAbilities.includes(id)
      ).length;

      return checkedCount > 0 && checkedCount < ids.length;
    },

    toggleAll(group, checked) {
      const ids = this.getGroupIds(group);

      if (checked) {
        this.selectedAbilities = Array.from(
          new Set([...this.selectedAbilities, ...ids])
        );
      } else {
        this.selectedAbilities = this.selectedAbilities.filter(
          (id) => !ids.includes(id)
        );
      }
    },

    save() {
      this.$vs.loading();
      providerApiService
        .addAbilities(
          this.currentProvider.id,
          this.selectedEmployee.id,
          this.selectedAbilities
        )
        .then(() => {
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد",
            color: "success",
            position: "bottom-center",
          });
          window.location.reload();
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => this.$vs.loading.close());
    },

    deleteEmployee() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "حذف کارمند",
        text: `از حذف کارمند "${
          this.selectedEmployee.name || this.selectedEmployee.phone
        }" اطمینان دارید؟`,
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => {
          this.$vs.loading();
          providerApiService
            .deleteEmployee(
              this.currentProvider.id,
              this.selectedEmployee.phone
            )
            .then(() => {
              this.$emit("employeeDeleted");
              this.$vs.notify({
                text: "کارمند با موفقیت حذف شد",
                position: "bottom-center",
                color: "success",
              });
            })
            .finally(() => this.$vs.loading.close());
        },
      });
    },

    setGroupByAbilitiesData(data) {
      const orders = { title: "سفارشات", data: [] };
      const products = { title: "محصولات فروشگاه", data: [] };
      const panel = { title: "پنل مدیریتی", data: [] };

      data.forEach((item) => {
        switch (item.scope) {
          case "orders":
            orders.data.push(item);
            break;
          case "categories":
          case "items":
            products.data.push(item);
            break;
          default:
            panel.data.push(item);
        }
      });

      this.abilities = [orders, products, panel];
    },
  },

  watch: {
    selectedEmployee(employee) {
      this.getAbilities(employee.id);
    },
  },
};
</script>


<style scoped lang="scss">
.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.ability-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 700px;
  float: left;
}

.desc-cont {
  margin-bottom: 0px;
}

.desc {
  color: #000000;
  font-size: 1.1rem;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
</style>